import { createUseStyles } from 'react-jss';

import { ViboTheme } from 'types/theme';

const useStyles = createUseStyles((theme: ViboTheme) => ({
  previewInfo: {
    '& .previewPhoto': {
      width: '48px',
      height: '48px',
      margin: '10px 0 23px 0',

      '@media screen and (min-width: 1441px)': {
        width: '64px',
        height: '64px',
        margin: '10px 0 21px 0',
      },
    },

    '& h3': {
      margin: '0!important',
    },
  },

  input: {
    width: '100%',
    height: '30px',
    fontSize: '15px',
    lineHeight: '21.25px',
    fontWeight: 400,
    background: theme.palette.background.default,
    borderRadius: '4px',
    border: '0',
    transition: 'unset',
    padding: '4px 36px',

    '& > input': {
      width: '100%',
      height: '30px',
      fontSize: '15px',
      lineHeight: '21.25px',
      fontWeight: 400,
      backgroundColor: theme.palette.background.default,
      borderRadius: '4px',
      border: '0',
      transition: 'unset',
      padding: '4px 36px',
      position: 'absolute',
      left: '0',
      top: '0',

      '@media screen and (min-width: 1441px)': {
        fontSize: '18px',
        lineHeight: '25.5px',
        height: '36px',
      },
    },

    '@media screen and (min-width: 1441px)': {
      fontSize: '18px',
      lineHeight: '25.5px',
      height: '36px',
    },
  },

  forgotPassword: {
    margin: '0 0 4px auto',
    color: theme.palette.primary.main,
  },

  inputGroup: {
    position: 'relative',
  },

  passowrdInput: {
    position: 'relative',

    '& input': {
      paddingLeft: '32px',
    },
  },

  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 0 5px 0',

    '@media screen and (min-width: 1441px)': {
      margin: '0 0 7px 0',
    },
  },

  inputIcon: {
    zIndex: 1,
    position: 'absolute',
    left: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: theme.palette.primary.main,

    '& svg': {
      width: '16px',
      height: '16px',
    },
  },

  orDivider: {
    width: '100%',
    textAlign: 'center',
    fontSize: '16px',
    margin: '9px 0 12px',

    '@media screen and (min-width: 1441px)': {
      margin: '11px 0 14px',
    },
  },

  extraLigonButtons: {
    display: 'flex',
    flexDirection: 'column',

    '& .appleLogin': {
      marginBottom: '8px',
    },
  },

  bookCall: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '18px 0 0 0',
    color: theme.palette.text.secondary,
    fontSize: '13px',
    lineHeight: '18.42px',

    '& .text': {
      marginRight: '5px',
    },

    '@media screen and (min-width: 1441px)': {
      fontSize: '16px',
      lineHeight: '22.67px',
    },
  },

  errorMessage: {
    minHeight: '17.5px',
    fontSize: '12px',
    color: theme.palette.error.main,
    textAlign: 'end',
  },

  errorContainer: {
    '& > div': {
      position: 'relative',
      boxShadow: theme.shadows[0],
      top: '50px',
    },
  },
}));

export default useStyles;
